export default __webpack_public_path__ + "static/media/p2023-46.df73bcfb.jpeg";